import { ErrorHandler } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { shouldDropAngularError } from './sentry-event-filter.util';

export const createFilteredSentryErrorHandler = (): ErrorHandler => {
  const sentryHandler = Sentry.createErrorHandler({ showDialog: false });

  return {
    handleError: (error: unknown): void => {
      if (shouldDropAngularError(error)) {
        return;
      }

      sentryHandler.handleError(error);
    }
  };
};
